<template>
    <div class="pending-approval">
        <div class="blocks-list">
            <div class="block-item" v-for="block in blocks" :key="block._id">
                <div class="block-info">
                    <span class="material-icons block-icon">{{ block.icon || "extension" }}</span>
                    <div class="block-details">
                        <h3>{{ block.name }}</h3>
                        <p>{{ block.description }}</p>
                        <div class="block-meta">
                            <span class="creator">
                                {{ $t("chatbotv2.creator") || "Creator" }}: {{ block.siteId }}
                            </span>
                            <span class="created-date">
                                {{ formatDate(block.createdAt) }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="block-actions">
                    <a-button size="small" @click="viewDetails(block._id)">
                        <a-icon type="eye" />
                        {{ $t("chatbotv2.viewDetails") || "View" }}
                    </a-button>
                    <a-button size="small" type="primary" @click="approveBlock(block._id)">
                        <a-icon type="check" />
                        {{ $t("chatbotv2.approve") || "Approve" }}
                    </a-button>
                    <a-button size="small" type="danger" @click="rejectBlock(block._id)">
                        <a-icon type="close" />
                        {{ $t("chatbotv2.reject") || "Reject" }}
                    </a-button>
                </div>
            </div>
        </div>

        <div class="empty-state" v-if="blocks.length === 0">
            <a-empty :description="$t('chatbotv2.noPendingBlocks') || 'No pending blocks'" />
        </div>

        <!-- Rejection Reason Modal -->
        <Modal2
            v-if="showRejectionModal"
            :title="$t('chatbotv2.rejectBlock') || 'Reject Block'"
            :description="$t('chatbotv2.enterRejectionReason') || 'Enter rejection reason'"
            :okText="$t('chatbotv2.reject') || 'Reject'"
            :cancelText="$t('message.cancel') || 'Cancel'"
            @ok="confirmReject"
            @cancel="showRejectionModal = false"
        >
            <a-textarea
                v-model="rejectionReason"
                :rows="5"
                :placeholder="$t('auto.blockRejectionReasonPlaceholder')"
            />
        </Modal2>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import Modal2 from "../../../../../components/common/Modal2.vue";

export default {
    name: "PendingApproval",
    components: {
        Modal2,
    },
    data() {
        return {
            showRejectionModal: false,
            rejectionReason: "",
            selectedBlockId: null,
        };
    },
    computed: {
        ...mapState({
            blocks: (state) => state.customBlocks.pendingApproval,
        }),
    },
    methods: {
        ...mapActions({
            listPendingApproval: "customBlocks/listPendingApproval",
            approveBlockAction: "customBlocks/approveBlock",
            rejectBlockAction: "customBlocks/rejectBlock",
        }),
        formatDate(date) {
            return moment(date).format("DD/MM/YYYY HH:mm");
        },
        viewDetails(blockId) {
            this.$emit("view-details", blockId);
        },
        async approveBlock(blockId) {
            try {
                await this.approveBlockAction(blockId);
                this.$message.success(this.$t("chatbotv2.blockApproved") || "Block approved successfully");
            } catch (error) {
                this.$message.error(error.message || "Failed to approve block");
            }
        },
        rejectBlock(blockId) {
            this.selectedBlockId = blockId;
            this.rejectionReason = "";
            this.showRejectionModal = true;
        },
        async confirmReject() {
            try {
                this.showRejectionModal = false;
                await this.rejectBlockAction({ id: this.selectedBlockId, reason: this.rejectionReason || "" });
                this.$message.success(this.$t("chatbotv2.blockRejected") || "Block rejected");
            } catch (error) {
                this.$message.error(error.message || "Failed to reject block");
            }
        },
    },
    created() {
        this.listPendingApproval();
    },
};
</script>

<style lang="scss" scoped>
.pending-approval {
    .blocks-list {
        display: flex;
        flex-direction: column;
        gap: 16px;

        .block-item {
            background: #fff;
            border: 1px solid #e0e0e0;
            border-radius: 8px;
            padding: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .block-info {
                display: flex;
                gap: 16px;
                flex: 1;

                .block-icon {
                    font-size: 48px;
                    color: #ff9800;
                }

                .block-details {
                    flex: 1;

                    h3 {
                        margin: 0 0 8px 0;
                        font-size: 18px;
                    }

                    p {
                        margin: 0 0 12px 0;
                        color: #666;
                        font-size: 14px;
                    }

                    .block-meta {
                        display: flex;
                        gap: 16px;
                        font-size: 13px;
                        color: #999;
                    }
                }
            }

            .block-actions {
                display: flex;
                gap: 8px;
            }
        }
    }

    .empty-state {
        min-height: 400px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>

